import { Text } from '@chakra-ui/react';
import React, { ReactElement } from 'react';

type Props = {
  count: number;
  searchQuery?: string;
};

export const SearchResultText = ({ count, searchQuery }: Props): ReactElement => {
  return (
    <Text textStyle="16.reg" color="text.quaternary">
      {count} Suchergebnisse für &quot;{searchQuery}&quot;
    </Text>
  );
};
